/* section-hero-banner.js — extracted from sections/hero-banner.liquid */
(function() {
    function initHeroSlider(section) {
      if (!section) return;
      var track = section.querySelector('.hero-slides-track');
      var slides = section.querySelectorAll('.hero-slide-item');
      var dots = section.querySelectorAll('.hero-dot-btn');
      var prevBtn = section.querySelector('.hero-arrow-prev');
      var nextBtn = section.querySelector('.hero-arrow-next');
      var totalSlides = slides.length;

      if (totalSlides <= 1) return;

      var currentIndex = 0;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = section.dataset.autoplay === 'true' && !reduceMotion;
      var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
      var transition = section.dataset.transition || 'slide';
      var pauseOnHover = section.dataset.pauseOnHover === 'true';
      var timer = null;

      function goToSlide(index) {
        if (index < 0) {
          currentIndex = totalSlides - 1;
        } else if (index >= totalSlides) {
          currentIndex = 0;
        } else {
          currentIndex = index;
        }

        if (transition === 'slide') {
          track.style.transform = 'translate3d(-' + (currentIndex * 100) + '%, 0, 0)';
        }

        slides.forEach(function(slide, idx) {
          if (idx === currentIndex) {
            slide.classList.add('is-active');
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.classList.remove('is-active');
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        dots.forEach(function(dot, idx) {
          if (idx === currentIndex) {
            dot.classList.add('is-active');
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.classList.remove('is-active');
            dot.setAttribute('aria-selected', 'false');
          }
        });
      }

      function startAutoplay() {
        if (!autoplay || timer) return;
        timer = setInterval(function() {
          goToSlide(currentIndex + 1);
        }, autoplaySpeed);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      // Initial state
      goToSlide(0);
      startAutoplay();

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          stopAutoplay();
          goToSlide(currentIndex - 1);
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          stopAutoplay();
          goToSlide(currentIndex + 1);
          startAutoplay();
        });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var targetIndex = parseInt(dot.dataset.index, 10);
          stopAutoplay();
          goToSlide(targetIndex);
          startAutoplay();
        });
      });

      if (pauseOnHover) {
        section.addEventListener('mouseenter', stopAutoplay);
        section.addEventListener('mouseleave', startAutoplay);
      }

      // Touch gestures for mobile swipe
      var startX = 0;
      var diffX = 0;
      var isDragging = false;

      section.addEventListener('touchstart', function(e) {
        if (e.touches.length === 1) {
          startX = e.touches[0].clientX;
          isDragging = true;
          stopAutoplay();
        }
      }, { passive: true });

      section.addEventListener('touchmove', function(e) {
        if (!isDragging) return;
        diffX = e.touches[0].clientX - startX;
      }, { passive: true });

      section.addEventListener('touchend', function() {
        if (!isDragging) return;
        isDragging = false;
        if (diffX > 45) {
          goToSlide(currentIndex - 1);
        } else if (diffX < -45) {
          goToSlide(currentIndex + 1);
        }
        diffX = 0;
        startAutoplay();
      }, { passive: true });

      // Keyboard navigation
      section.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          stopAutoplay();
          goToSlide(currentIndex - 1);
          startAutoplay();
        } else if (e.key === 'ArrowRight') {
          stopAutoplay();
          goToSlide(currentIndex + 1);
          startAutoplay();
        }
      });

      // Shopify customizer integration
      document.addEventListener('shopify:block:select', function(e) {
        if (e.target && section.contains(e.target)) {
          stopAutoplay();
          var slideIndex = Array.prototype.indexOf.call(slides, e.target);
          if (slideIndex >= 0) {
            goToSlide(slideIndex);
          }
        }
      });

      document.addEventListener('shopify:block:deselect', function(e) {
        if (e.target && section.contains(e.target)) {
          startAutoplay();
        }
      });
    }

    function __initSectionHeroBanner1() {
      var heroSections = document.querySelectorAll('.hero-banner-slider-root');
      heroSections.forEach(initHeroSlider);
    }
    document.addEventListener('DOMContentLoaded', __initSectionHeroBanner1);
    document.addEventListener('shopify:section:load', __initSectionHeroBanner1);
    if (document.readyState !== 'loading') __initSectionHeroBanner1();

    document.addEventListener('shopify:section:load', function(e) {
      if (e.target) {
        var slider = e.target.querySelector('.hero-banner-slider-root');
        if (slider) initHeroSlider(slider);
      }
    });
  })();
